import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import leaveReportComponent from './leave-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let leaveReportModule = angular.module('leavereport', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('leavereport', {
    parent: 'app',
    url: '/admin/reports/leave',
    data: {
      pageHeader: true,
      pageTitle: 'Leave Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<leavereport></leavereport>'
  });

})

.component('leavereport', leaveReportComponent);

export default leaveReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/leave-report/leave-report.js